<template>
    <div>
        <div class="pagetitle">
            <h1>Vehicle</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Vehicle</li>
                </ol>
            </nav>
        </div>
        <div class="row-mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Kendaraan</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" class="form-control" placeholder="Cari Kendaraan" v-model="searchQuery" @change="fetchVehicles">
                            <div class="from-group mb-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select id="pageSize" v-model="pageSize" @change="fetchVehicles" class="form-select">
                                    <option v-for="size in [1, 5, 10, 15, 20, 100]" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Gambar</th>
                                        <th scope="col">Dimensi </th>
                                        <th scope="col">Maks. Bobot</th>
                                        <th scope="col">Volume</th>
                                        <th scope="col">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(vehicle, index) in filteredVehicles" :key="vehicle.id">
                                        <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                        <td>{{ vehicle.name }}</td>
                                        <td><img :src="vehicle.image_url" width="100" height="100" /></td>
                                        <td>{{ vehicle.length }} x {{ vehicle.width }} x {{ vehicle.height }}</td>
                                        <td>{{ vehicle.max_weight }} kg</td>
                                        <td>{{ vehicle.volume }}</td>
                                        <td>
                                            <span :class="vehicle.is_active == 1 ? 'badge bg-success' : 'badge bg-danger'">
                                                {{ vehicle.is_active == 1 ? 'Active' : 'Inactive' }}
                                            </span>
                                        </td> 
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="fetchVehicles">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vehiclejs from './jsVehicle/vehicle';
export default vehiclejs;
</script>